// extracted by css-extract-rspack-plugin
var _1 = "j-41kLpNXCQhdcOGuqHbzg--";
export { _1 as "container" }
